import styled from 'styled-components';

const CardBorderedDiv = styled.div`
  // padding: 100px 40px 40px 40px;
  padding: 40px;
  overflow: auto;
`;

export default CardBorderedDiv;
